/** A settings panel's small uppercase section heading. */
export const SectionLabel = ({ children }: { children: string }) => (
  <span className="text-xs font-bold uppercase tracking-wide text-foreground-muted">
    {children}
  </span>
);
